module.exports = __webpack_public_path__ + "assets/static/jpg/prepaid.6f8b9a01b61200d5fcd98ebf142cf6ed.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/prepaid.jpg
 ** module id = 503
 ** module chunks = 1
 **/